import { Color } from '@trevor/ui-components';
import {
  EMAIL,
  SLACK,
  ZAPIER,
} from '@/features/credits/alertCategory.constants';
import { TConsumptionCategory, TConsumptionCategoryAndType } from './types';
import {
  AD_HOC_QUERY,
  ALERT,
  DASHBOARD,
  FEED,
  SAVED_QUERY,
  REPORT,
} from './category.constants';

export const CONSUMPTION_CATEGORY_TO_COLORS: Record<
  TConsumptionCategory,
  { main: Color; highlight: Color }
> = {
  [AD_HOC_QUERY]: {
    main: '#53AEF3',
    highlight: '#CFE8FC',
  },
  [ALERT]: {
    main: '#8D6CEF',
    highlight: '#EAE3FC',
  },
  [DASHBOARD]: {
    main: '#5AC8A2',
    highlight: '#BEE9DA',
  },
  [FEED]: {
    main: '#DB6666',
    highlight: '#F4D2D2',
  },
  [SAVED_QUERY]: {
    main: '#FF9752',
    highlight: '#FFE7D6',
  },
  [REPORT]: {
    main: '#FFCA38',
    highlight: '#FFEDBD',
  },
};

export const COLOR_TO_CONSUMPTION_CATEGORY: Record<
  Color,
  TConsumptionCategory
> = {
  '#53AEF3': AD_HOC_QUERY,
  '#8D6CEF': ALERT,
  '#5AC8A2': DASHBOARD,
  '#DB6666': FEED,
  '#FF9752': SAVED_QUERY,
  '#FFCA38': REPORT,
};

export const CONSUMPTION_CATEGORY_TO_DISPLAY_NAME: Record<
  TConsumptionCategory,
  string
> = {
  [AD_HOC_QUERY]: 'Ad-hoc queries',
  [ALERT]: 'Alerts',
  [DASHBOARD]: 'Dashboards',
  [FEED]: 'Feeds',
  [SAVED_QUERY]: 'Queries',
  [REPORT]: 'Reports',
};

export const CONSUMPTION_CATEGORY_TYPE_TO_DISPLAY_NAME: Record<
  TConsumptionCategoryAndType,
  string
> = {
  [AD_HOC_QUERY]: 'Ad-hoc queries',
  [SAVED_QUERY]: 'Saved queries',
  [DASHBOARD]: 'Dashboards',
  [REPORT]: 'Reports',
  [FEED]: 'Feeds',
  [`${ALERT}:${EMAIL}` as const]: 'Email Alerts',
  [`${ALERT}:${SLACK}` as const]: 'Slack Alerts',
  [`${ALERT}:${ZAPIER}` as const]: 'Zapier Alerts',
};

export const CONSUMPTION_CATEGORY_HOVER_EVENT =
  'trevor:consumption-category-hovered';

export const CATEGORY_TO_TITLE_MAP: PRecord<TConsumptionCategory, string> = {
  [AD_HOC_QUERY]: 'User',
  [DASHBOARD]: 'Dashboard',
};
